export default __webpack_public_path__ + "static/media/spider-blood.75aa6c4a.jpg";